interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Tron = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="100"
      height="100"
      rx="50"
      fill="#FF060A"
    />
    <path
      d="M77.7031 38.0749C74.8906 35.4781 71 31.5124 67.8312 28.6999L67.6437 28.5687C67.3318 28.3182 66.98 28.1217 66.6031 27.9874C58.9625 26.5624 23.4031 19.9156 22.7094 19.9999C22.515 20.0272 22.3292 20.0976 22.1656 20.2062L21.9875 20.3468C21.7682 20.5696 21.6016 20.8387 21.5 21.1343L21.4531 21.2562V21.9218V22.0249C25.4562 33.1718 41.2625 69.6874 44.375 78.2562C44.5625 78.8374 44.9188 79.9437 45.5844 79.9999H45.7344C46.0906 79.9999 47.6094 77.9937 47.6094 77.9937C47.6094 77.9937 74.7594 45.0687 77.5062 41.5624C77.8618 41.1305 78.1757 40.666 78.4437 40.1749C78.5122 39.7908 78.4799 39.3954 78.3501 39.0274C78.2203 38.6593 77.9974 38.3312 77.7031 38.0749ZM54.575 41.9093L66.1625 32.2999L72.9594 38.5624L54.575 41.9093ZM50.075 41.2812L30.125 24.9312L62.4031 30.8843L50.075 41.2812ZM51.875 45.5656L72.2937 42.2749L48.95 70.3999L51.875 45.5656ZM27.4156 26.5624L48.4062 44.3749L45.3687 70.4187L27.4156 26.5624Z"
      fill="white"
    />
  </svg>
);
